<template>
  <Modal ref="modalRef" class="notice" v-bind="$attrs" v-on="$listeners">
    <div
      v-for="(item, index) in noticeList"
      v-show="index + 1 == activePage"
      :key="index"
    >
      <p class="notice-title">{{ item.title }}</p>
      <p class="notice-content">
        {{ item.content }}
      </p>
    </div>
    <div class="notice-pagination" v-if="noticeList.length > 1">
      <span
        v-for="item in noticeList.length"
        :key="item"
        :class="{ active: item == activePage }"
        class="page"
        @click="updatePage(item)"
        >{{ item }}</span
      >
    </div>
    <div class="notice-footer">
      <Button class="notice-footer-cancel" @click="closePopup">
        {{ languages.smartOrderIKnow }}
      </Button>
    </div>
  </Modal>
</template>

<script>
export default {
  props: ['languages', 'noticeList'],
  data() {
    return {
      operateType: '',
      activePage: 1
    };
  },
  methods: {
    closePopup() {
      this.$refs?.modalRef?.closeModal();
    },
    updatePage(page) {
      this.activePage = page;
    }
  }
};
</script>

<style lang="scss" scoped>
.notice {
  &-title {
    margin-top: 6px;
    margin-bottom: 20px;
    font-size: 18px;
    text-align: center;
  }
  &-content {
    line-height: 20px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #666666;
    min-height: 80px;
  }
  &-pagination {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin: 30px 0;
    .page {
      display: inline-block;
      width: 30px;
      height: 30px;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      border-radius: var(--border-radius);
      &.active {
        background-color: var(--main-color);
        color: var(--text-on-main-bg-color);
      }
    }
  }

  &-footer {
    &-cancel {
      width: 100%;
      flex: 1;
      height: 50px !important;
      border-radius: 6px !important;
      font-size: 18px !important;
    }
  }
}
</style>
